var SignupConfirmation = (function ($) {

    SignupConfirmation = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$preload = that.$wrapper.find('.js-preload');
        that.$error = that.$wrapper.find('.js-error');
        that.$success = that.$wrapper.find('.js-success');

        // CONST
        that.login_hash = options['login_hash'];
        that.code_hash = options['code_hash'];
        that.contact_id_hash = options['contact_id_hash'];

        that.urls = {
            confirmation: 'auth/signup/confirmation-perform'
        };

        // HANDLERS
        that.onError = (options['onError'] || false); // for phone (staying in the same window)

        // DYNAMIC VARS

        // INIT
        that.init(options['send_immediately']);
    };

    SignupConfirmation.prototype.init = function (send_immediately) {
        var that = this;

        if (true === send_immediately) {
            that.send();
        }
    };

    SignupConfirmation.prototype.send = function () {
        var that = this,
            href = $.sa.build_url(that.urls.confirmation),
            data = {
                login_hash: that.login_hash,
                code_hash: that.code_hash,
                cid: that.contact_id_hash
            };

        if (that.$preload.length) {
            that.$preload.show();
        }
        $.post(href, data, function (response) {
            if (response && response.status === 'ok' && response.data === true) {
                if (that.$success.length) {
                    that.$success.show();
                }
            } else {
                if (response.errors) {
                    $.sa.log(response.errors);
                    if (that.$error.length) {
                        var text = [];
                        response.errors.forEach(function(error) {
                            if (error.hasOwnProperty('message')) {
                                text.push(error.message);
                            }
                        });
                        that.$error.text(text.join('<br/>'));
                    }
                }
                if (that.$error.length) {
                    that.$error.show();
                }
                if (typeof that.onError === 'function') {
                    that.onError(that);
                }
            }
        })
            .fail(function(jqXHR) {
                $.sa.log(jqXHR.responseText);
                if (that.$error.length) {
                    that.$error.show();
                }
                if (typeof that.onError === 'function') {
                    that.onError(that);
                }
            })
            .always(function (response) {
                if (that.$preload.length) {
                    that.$preload.hide();
                }
            });
    };

    return SignupConfirmation;

})($);